import { clearGlobalMessage, setGlobalErrorMessage, setGlobalSuccessMessage } from './app-global-values';

/*
    requestFunctionReturningPromise must be axios response.
    onSuccess and onError would set global msg.

    https://github.com/axios/axios#handling-errors
*/
export const returnResponseIfOkOrSetGlobalErrorMessage = (
  requestFunctionReturningPromise,
  errorMessagePrefix,
  successMessage = '',
  throwError = false
) => {
  clearGlobalMessage();
  return requestFunctionReturningPromise()
    .then(response => {
      // any 2xx response
      if (successMessage && successMessage.length > 0) {
        setGlobalSuccessMessage(successMessage);
      }
      return Promise.resolve(response);
    })
    .catch(error => {
      // any non 2xx response
      setGlobalErrorMessage(
        `${errorMessagePrefix}: ${
          error?.response ? `${error.response.status} - ${JSON.stringify(error.response.data)}` : ''
        }`
      );
      if (throwError) {
        throw error;
      }
      return Promise.resolve(null);
    });
};
